import { render, staticRenderFns } from "./edit-procedure.vue?vue&type=template&id=7e863c1a&scoped=true&"
import script from "./edit-procedure.vue?vue&type=script&lang=js&"
export * from "./edit-procedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e863c1a",
  null
  
)

export default component.exports